"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskAssessmentPrediction = void 0;
/**
 * An assessment of the likely outcome(s) for a patient or other subject as well as the likelihood of each outcome.
 */
var RiskAssessmentPrediction = /** @class */ (function () {
    function RiskAssessmentPrediction() {
    }
    return RiskAssessmentPrediction;
}());
exports.RiskAssessmentPrediction = RiskAssessmentPrediction;
